import React, { FC, PropsWithChildren, useCallback, useMemo } from 'react';
import { Spinner } from '../../catalyst-components/spinner';

interface LoadingWrapperProps {
  isLoading: boolean;
}

export const useLoadingWrapper = ({ isLoading }: LoadingWrapperProps) => {
  return useMemo(() => {
    return ({ children }: PropsWithChildren) => {
      if (isLoading) {
        return (
          <div className="flex justify-center items-center h-screen">
            <Spinner className="w-16 h-16" />
          </div>
        );
      }
      return <>{children}</>;
    };
  }, [isLoading]);
}; 